import {
  FormControl,
  FormHelperText,
  FormLabel,
  Grid,
  Icon,
} from '@mui/material';
import {
  DateValidationError,
  PickerChangeHandlerContext,
} from '@mui/x-date-pickers';
import { Dayjs } from 'dayjs';
import DatePicker from 'react-multi-date-picker';
import InputIcon from 'react-multi-date-picker/components/input_icon';
import BakeasyDatePicker, { BakeasyDueDatePicker } from './BakeasyDatePicker';
import { t } from 'i18next';
import { ERROR } from '../../constants/Colors';

interface BakeasyDateRangePickerRProps {
  label: string;
  value?: any;
  required?: any;
  disabled?: boolean;
  viewAllOrders?: boolean | false;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>, params?: any) => void;
  onChange?: (value: any) => void;
}

export function BakeasyDateRangePickerR(props: BakeasyDateRangePickerRProps) {
  return (
    <FormControl fullWidth>
      <FormLabel
        sx={{ fontWeight: 'bold', fontSize: '0.95rem', marginBottom: 0.5 }}
      >
        {props.label}
        {props?.required ? ' *' : ''}
      </FormLabel>
      <DatePicker
        placeholder={t('DUE_DATE')}
        value={props?.value}
        format={'MM-DD-YYYY'}
        // views={['year', 'month', 'day']}
        // format={'MM/DD/YYYY'}
        range
        rangeHover
        portal
        disabled={props?.disabled}
        // style={{
        //   height: '38px',
        //   width: '100%',
        //   borderRadius: 8,
        //   padding: 10,
        //   fontSize: '0.9rem'
        // }}
        render={
          <InputIcon
            aria-placeholder="dsf"
            style={{
              height: '100%',
              width: '100%',
              borderRadius: 8,
              padding: 10,
              fontSize: '0.9rem',
            }}
          />
        }
        onChange={(newValue: any) => {
          props?.onChange && props?.onChange(newValue);
        }}
      />
    </FormControl>
  );
}

interface BakeasyDateRangePickerProps {
  label?: string;
  requestedDeliveryDateFrom?: Dayjs | null;
  requestedDeliveryDateTo?: Dayjs | null;
  required?: boolean;
  disabled?: boolean;
  onRequestedDeliveryDateFromChange?: (
    value: Dayjs | null,
    context: PickerChangeHandlerContext<DateValidationError>
  ) => void;
  onRequestedDeliveryDateToChange?: (
    value: Dayjs | null,
    context: PickerChangeHandlerContext<DateValidationError>
  ) => void;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>, params?: any) => void;
  error?: string;
}

function BakeasyDateRangePicker(props: BakeasyDateRangePickerProps) {
  return (
    <FormControl fullWidth>
      {props.label && (
        <FormLabel
          sx={{ fontWeight: 'bold', fontSize: '0.95rem', marginBottom: 0.5 }}
        >
          {props.label}
          {props.required ? ' *' : ''}
        </FormLabel>
      )}
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <BakeasyDatePicker
            label={t('ORDERS_DUE_FROM')}
            value={props.requestedDeliveryDateFrom}
            onChange={props.onRequestedDeliveryDateFromChange}
            disabled={props.disabled}
            required={true}
          />
        </Grid>
        <Grid item xs={6}>
          <BakeasyDatePicker
            label={t('ORDERS_DUE_TO')}
            value={props.requestedDeliveryDateTo}
            onChange={props.onRequestedDeliveryDateToChange}
            disabled={props.disabled}
            required={true}
            //onClick={props?.onClick && props?.onClick}
          />
        </Grid>
      </Grid>
      {props.error && (
        <FormHelperText
          sx={{ color: ERROR, fontSize: '0.8rem', marginTop: 0.5 }}
        >
          {props.error}
        </FormHelperText>
      )}
    </FormControl>
  );
}

export default BakeasyDateRangePicker;
